import {
  BATCH_SIZES_COMBINED_OPTIONS,
  BUDGET_RANGES_OPTIONS,
  ENGAGEMENT_SCALES_OPTIONS,
  SPEED_TO_START_OPTIONS,
} from './index';

/**
 * Default Tier-2 slider value: direct multiplier on earned and max marks (weighted match %).
 */
export const DEFAULT_TIER2_SLIDER_MULTIPLIER = 3;

/**
 * Default base weights (mirrors DB `scoring_base_weights` seed).
 * Merged at runtime with DB values via `resolveBaseScoreWeights` in `scoringEngine`.
 */
export const BASE_SCORE_WEIGHTS = {
  batch_size: 25,
  development_stage: 25,
  speed_to_start: 20,
  budget: 15,
  geography: 10,
  support_services: 5,
} as const;

/** Batch-size tiers for scoring — same labels as CDMO profile / matching forms. */
export const BATCH_SIZE_TIER_ORDER: readonly string[] = BATCH_SIZES_COMBINED_OPTIONS;

/** Development engagement tiers — same as {@link ENGAGEMENT_SCALES_OPTIONS}. */
export const DEVELOPMENT_STAGE_ORDER: readonly string[] = ENGAGEMENT_SCALES_OPTIONS;

/** Speed-to-start options — same as {@link SPEED_TO_START_OPTIONS}. */
export const SPEED_TO_START_ORDER: readonly string[] = SPEED_TO_START_OPTIONS;

/**
 * Whether a stored speed-to-start value is one the scoring engine can interpret.
 *
 * Enforced when writing a CDMO profile: a value outside this list scores zero on the
 * speed dimension rather than failing loudly, so it must never reach the table.
 */
export const isCanonicalSpeedToStart = (value: string): boolean =>
  SPEED_TO_START_ORDER.includes(value);

/** Budget bands (cheapest → highest) — same as {@link BUDGET_RANGES_OPTIONS}. */
export const BUDGET_BAND_ORDER: readonly string[] = BUDGET_RANGES_OPTIONS;

/**
 * Regions treated as “adjacent” for partial geography score.
 * Separate from {@link CROSS_REGION_PAIRINGS} in `index` (used for broader UI/geo copy).
 */
export const SCORING_CROSS_REGION_PAIRINGS: Record<string, readonly string[]> = {
  'North America': ['Latin America'],
  Europe: ['North America'],
  'Asia-Pacific': ['Asia-Pacific'],
  'Latin America': ['North America'],
  'Middle East & Africa': [],
};
